/**
 * Kopplar en filterparameter till en config-egenskap på en rapport
 */
export class ParamData {
    /**
     * 
     * @param name Namn på filtret som visas för användaren
     * @param configId filtrets id i rapportens configobjekt
     * @param data filtrets data, [] per default.
     */
    constructor(
        public name: string = '',
        public configId: string = null,
        public data: any = [])
    { }
}
